export enum TooltipIconType {
	WARNING = 'warning',
	EXPIRED = 'expired',
	DOLLAR = 'dollar',
	EXPIRING = 'expiring',
	SMILE = 'smile',
	CUSTOM = 'custom',
	DEFAULT = 'default'
}
